module.exports = __webpack_public_path__ + "static/media/avatar.1d88924d.png";